if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');
        this.isSubmitting = false;

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;
        
        // Prevent multiple submissions
        if (this.isSubmitting) {
          return;
        }
        
        this.isSubmitting = true;
        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');
        
        // Note: Cart count animation is handled by cart-icon-bubble.liquid

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        
        if (this.cart) {
          const sections = this.cart.getSectionsToRender().map((section) => section.id);
          formData.append('sections', sections);
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => {
            if (!response.ok) {
              // Handle specific error cases
              if (response.status === 422) {
                throw new Error('ITEM_ALREADY_IN_CART');
              }
              throw new Error(`HTTP error! status: ${response.status}`);
            }
            return response.json();
          })
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              if (!Shopify.designMode) {
                window.location = window.routes.cart_url;
              }
              return;
            }

            // Show success message instead of opening cart drawer
            const successMessage = this.querySelector('.product__success-message');
            if (successMessage) {
              successMessage.style.display = 'block';
              // Hide success message after 3 seconds
              setTimeout(() => {
                successMessage.style.display = 'none';
              }, 3000);
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            
            // Dispatch custom cart update event for cart count animation
            if (response.item_count !== undefined) {
              document.dispatchEvent(new CustomEvent('cart:updated', {
                detail: {
                  item_count: response.item_count,
                  cartData: response
                }
              }));
            } else {
              // Fallback: fetch cart data to get updated count
              fetch('/cart.js')
                .then(response => response.json())
                .then(cartData => {
                  if (cartData.item_count !== undefined) {
                    document.dispatchEvent(new CustomEvent('cart:updated', {
                      detail: {
                        item_count: cartData.item_count,
                        cartData: cartData
                      }
                    }));
                  }
                })
                .catch(error => console.error('Error fetching cart data:', error));
            }
            
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              // Update cart drawer content without opening it
              if (this.cart) {
                // Update the cart drawer content silently (without opening)
                this.cart.getSectionsToRender().forEach((section) => {
                  const sectionElement = section.selector
                    ? document.querySelector(section.selector)
                    : document.getElementById(section.id);

                  if (!sectionElement) return;
                  
                  const sectionHTML = response.sections ? response.sections[section.id] : null;
                  if (!sectionHTML) return;
                  
                  const innerHTML = this.cart.getSectionInnerHTML(sectionHTML, section.selector);
                  if (innerHTML) {
                    sectionElement.innerHTML = innerHTML;
                  }
                });
                
                // Remove is-empty class if cart was empty
                if (this.cart.classList.contains('is-empty')) {
                  this.cart.classList.remove('is-empty');
                }
              }
            }
          })
          .catch((e) => {
            console.error('Cart add error:', e);
            if (e.message === 'ITEM_ALREADY_IN_CART') {
              this.handleErrorMessage('Ce produit est déjà dans votre panier.');
            } else {
              this.handleErrorMessage('Une erreur est survenue lors de l\'ajout au panier. Veuillez réessayer.');
            }
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
            this.isSubmitting = false;
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
